import { Component, inject } from '@angular/core';
import { environment } from 'src/environments/environment';
import { provideIcons } from '@ng-icons/core';
import { heroExclamationCircle } from '@ng-icons/heroicons/outline';
import {
  DynamicFormComponent,
  FormState,
} from 'src/app/shared/dynamic-form/dynamic-form.component';
import { DynamicFormConfiguration } from 'src/app/shared/dynamic-form/interfaces/dynamic-form-controls';
import { NgIf } from '@angular/common';
import { AppService } from 'src/app/app.service';

const arrayBufferToBase64 = (blob: ArrayBuffer) =>
  btoa(
    new Uint8Array(blob).reduce(
      (data, byte) => data + String.fromCharCode(byte),
      '',
    ),
  );

@Component({
  selector: 'app-claim',
  standalone: true,
  providers: [provideIcons({ heroExclamationCircle }), AppService],
  imports: [DynamicFormComponent, NgIf],
  styleUrls: ['./claim.component.scss'],
  template: `
    <div>
      <h2 class="text-3xl mb-4 px-4">Returer & Reklamationer</h2>
      <app-dynamic-form
        [config]="config"
        [turnstileSiteKey]="turnstileSiteKey"
        (submitted)="sendIt($event)"
        [state]="formState"
        [submitionId]="submitionId"
      ></app-dynamic-form>
    </div>
  `,
})
export class ClaimComponent {
  turnstileEnabled = environment.TURNSTILE_ENABLED;
  turnstileSiteKey? = this.turnstileEnabled
    ? environment.TURNSTILE_SITE_KEY
    : undefined;

  service = inject(AppService);

  config: DynamicFormConfiguration = {
    controls: [
      {
        type: 'invoice',
        name: 'invoiceNo',
        displayName: 'Fakturanummer',
        reqiuired: true,
      },
      {
        type: 'table',
        name: 'articles',
        section: 'order',
        columns: [
          { type: 'text', name: 'articleNo', displayName: 'Artikelnummer' },
          { type: 'text', name: 'quantity', displayName: 'Antal' },
        ],
      },
      { type: 'text', name: 'name', displayName: 'Ditt namn', reqiuired: true },
      {
        type: 'text',
        name: 'email',
        displayName: 'Din e-post',
        reqiuired: true,
      },
      {
        type: 'multiline',
        name: 'description',
        displayName: 'Beskriv ditt ärende',
        reqiuired: true,
      },
      { type: 'file', name: 'attachments', displayName: 'Bifoga fil' },
      { type: 'turnstile', name: 'turnstile' },
    ],
  };

  formState: FormState = 'idle';
  submitionId?: string;

  async sendIt(formData: { [key: string]: any }) {
    this.formState = 'loading';

    const attachments = formData['attachments'] as File[];
    const formattedAttachments = await Promise.all(
      attachments.map(async (file) => ({
        name: file.name,
        content: await file
          .arrayBuffer()
          .then((blob) => arrayBufferToBase64(blob)),
      })),
    );

    const request = {
      ...formData,
      attachments: formattedAttachments,
    };

    try {
      this.submitionId = await this.service.sendIt(request);
      this.formState = 'success';
    } catch (e) {
      this.formState = 'error';
    }
  }
}
